import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Form, Button, Container, Alert } from 'react-bootstrap';
import './LoginPage.css'; 

function LoginPage() {
  const [rut, setRut] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [variant, setVariant] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevenir el comportamiento predeterminado del formulario
    if (validateRut(rut)) {
        try {
        const response = await fetch('https://api.grekad.cfcunap.cl/api/login', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({ rut, password }),
        });

        const data = await response.json();

        if (data.success) {
            // Guardar el token en localStorage o sessionStorage
            localStorage.setItem('token', data.token);
          //console.log("Estado recibido en login:", location.state);
            // Redirigir a la página de inicio o a otra página
            //navigate('/ranking');
            const redirectTo = location.state?.from || '/ranking';
            navigate(redirectTo);
        } else {
            setMessage(data.message || 'Error al iniciar sesión.');
            setVariant('danger');
        }
        } catch (error) {
        setMessage('Error en la conexión con el servidor.');
        setVariant('danger');
        }
    } else {
        setMessage('Formato de RUT inválido. Ingrese el RUT sin puntos y con guion antes del dígito verificador.');
        setVariant('danger');
    }
  };
// Función para validar el formato del RUT
const validateRut = (rut) => {
    const rutRegex = /^[0-9]+-[0-9K]$/; // Solo números y un guion con dígito verificador
    return rutRegex.test(rut);
  };
  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <div className="login-form">
      <h3 className="text-center mb-4">Iniciar Sesión</h3>
      {message && <Alert variant={variant}>{message}</Alert>}

      <Form onSubmit={handleLogin}>
        <Form.Group controlId="rut"  className="mb-3">
          <Form.Label>RUT</Form.Label>
          <Form.Control
            type="text"
            placeholder="12123123-K"
            value={rut}
            onChange={(e) => setRut(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group controlId="password" className="mt-3">
          <Form.Label>Contraseña</Form.Label>
          <Form.Control
            type="password"
            placeholder="Ingresa tu contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </Form.Group>
        <div className="d-flex justify-content-center">
        <Button variant="primary" type="submit" className="mt-3">
          Iniciar Sesión
        </Button>
        </div>
      </Form>
      </div>
    </Container>
  );
}

export default LoginPage;
